import { getShipTos } from "@NA/Overrides/Services/CustomersService";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { RequestDataFromApi, chain } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";

import { ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    GetShipTosApiParameter & HasOnSuccess,
    GetShipTosApiParameter,
    ShipToCollectionModel
>;

export const RequestDataFromApiCustom: HandlerType = async props => {
    props.apiResult = await getShipTos(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiCustom);
